// Where the client came from: utm tags of the link they landed on (an AI
// assistant's link from the MCP server has utm_medium=mcp). Kept for 30 days
// and sent with the bid (core keeps them in the bid's addition_data).
const STORAGE_KEY = 'attribution';
const TTL_MS = 30 * 24 * 60 * 60 * 1000;
const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
] as const;

export type Attribution = Partial<Record<(typeof UTM_KEYS)[number], string>>;

interface Stored {
  tags: Attribution;
  at: number;
}

// the last link with utm tags wins; a visit without them keeps the old ones
export function rememberAttribution(search: string = window.location.search) {
  const params = new URLSearchParams(search);
  const tags: Attribution = {};

  UTM_KEYS.forEach((key) => {
    const value = params.get(key);
    if (value) tags[key] = value.slice(0, 100);
  });

  if (Object.keys(tags).length === 0) return;

  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ tags, at: Date.now() } as Stored)
    );
  } catch (e) {
    // storage off (private mode): the bid goes without tags
  }
}

export function getAttribution(): Attribution | undefined {
  try {
    const stored: Stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '');

    if (
      !stored ||
      typeof stored.at !== 'number' ||
      Date.now() - stored.at > TTL_MS
    ) {
      return undefined;
    }

    return stored.tags;
  } catch (e) {
    return undefined;
  }
}
